var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "draggableContainer",
      staticClass: "box-sign",
      attrs: { id: "draggable-container" }
    },
    [
      _c("div", { staticClass: "button-close", on: { click: _vm.closeSign } }, [
        _vm._v("x")
      ]),
      _c("div", _vm._g({}, _vm.handlers), [
        _c("div", { staticClass: "c-timbre" }),
        _vm.processType.toLowerCase() === "numerar"
          ? _c("div", { staticClass: "c-datos" }, [
              _c("div", { staticClass: "dato-numeration" }, [_vm._v(" NNN ")])
            ])
          : _vm._e(),
        _vm.processType.toLowerCase() === "tramitar"
          ? _c("div", { staticClass: "c-datos-process" }, [_vm._m(0)])
          : _vm._e(),
        _vm.processType.toLowerCase() === "fechar"
          ? _c("div", { staticClass: "c-date-process" }, [
              _c("div", { staticClass: "dato-date-process" }, [
                _vm._v(" 2022-04-01 ")
              ])
            ])
          : _vm._e()
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "dato-process" }, [_vm._v(" T ")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }